import { createSlice, current } from '@reduxjs/toolkit'

const tripFormSlice = createSlice({
  name: 'tripForm',
  initialState: {
   data : { tripname: '',
    destination:'',
    rPiker: '',
    email: '',
    cosphonu: '',
    securrency: '',
    ageRows: [],
    category:[],
    days: '',
  }
  },
  reducers: {

    updateUser: (state, action) => {
        const data = action.payload;
        state.data = {...state.data, ...data}
      },
    updateDestination: (state, action) => {
        const destination = action.payload;
        state.data = {...state.data, destination: destination }
      },
    AddAgeRow: (state, action) => {
        const ageRow = action.payload;
        state.data = {...state.data, ageRows: [...state.data.ageRows, ageRow] }
      },
    DeleteAgeRow: (state, action) => {
        const childRow = [...current(state.data.ageRows)]
        childRow.splice(-1);
        state.data = {...state.data, ageRows: [...childRow ] }
      },
    updateAge: (state, action) => {
       // const ageRow = action.payload;

        const id = action.payload.id
        const ageRows = current(state.data.ageRows)
  
        let copyageRows = [...ageRows]
        let fileteredAgeIndex = ageRows.findIndex(age => age.id == id);
    
        copyageRows[fileteredAgeIndex] =  action.payload
        state.data.ageRows = [...copyageRows]


        state.data.ageRows = [...state.data.ageRows]
      },
      updateMailId: (state, action) => {
        const mailId = action.payload;
        state.data = {...state.data, email: mailId}
      },
      updatePhoneNumber: (state, action) => {
        const phoneNumber = action.payload;
        state.data = {...state.data, cosphonu: phoneNumber}
      }, 
      updateCurrency: (state, action) => {
        const currency = action.payload;
        state.data = {...state.data, securrency: currency}
      }, 
      updateCategory: (state, action) => {
        const selectedCategory = action.payload;
        
        state.data.category = [...selectedCategory]
      }, 
      updateDateRange: (state, action) => {
        const dateRange = {...action.payload};
        dateRange.startDate = dateRange.startDate.toString();
        
        state.data = {...state.data, rPiker: dateRange}
        
      }, 
      updateDaysCount: (state, action) => {
        const daysCount = action.payload;
        state.data = {...state.data, days: daysCount}
        
      },

      
    
    // addNotes: (state, action) => {
    //   state.data = [...state.data, action.payload]
    // },
    // updateNote: (state, action) => {
    //   const id = action.payload.id
    //   const notes = current(state.data)

    //   let copyNote = [...notes]
    //   let fileteredNoteIndex = notes.findIndex(note => note.id == id);
  
    //   copyNote[fileteredNoteIndex] =  action.payload
    //   state.data =[...copyNote]
    // }, 
    // deleteNotes: (state, action) => {
    //   const id = action.payload.id
    //   const notes = current(state.data)

      
    //   let fileteredNote = notes.filter(note => note.id !== id);
  
      
    //   state.data =[...fileteredNote]

    // }
  },
})

// action creators
export const {
    updateUser,
    updateDestination,
    AddAgeRow,
    updateAge,
    DeleteAgeRow,
    updateMailId,
    updatePhoneNumber,
    updateCurrency,
    updateCategory,
    updateDateRange,
    updateDaysCount,
  // getNotes,
//   addNotes,
//   updateNote,
//   deleteNotes,
} = tripFormSlice.actions

export const fetchCurrentTripForm = (state) => state.tripForm.data

export default tripFormSlice.reducer
